import { useApi } from "@backstage/core-plugin-api";
import { Checkbox } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { opsReviewApiRef } from "../../api/OpsReviewApi";

interface Props {
  incidentId: string;
  disabled?: boolean;
}

export const ReviewCheckbox: React.FC<Props> = ({
  incidentId,
  disabled,
}): JSX.Element => {
  const opsReviewApi = useApi(opsReviewApiRef);
  const [reviewed, setReviewed] = useState<boolean>(false);
  const [incident, setIncident] = useState<any>();

  useEffect(() => {
    (async () => {
      const incidentResponse = await opsReviewApi.getReviewedIncident(
        incidentId
      );
      const data = incidentResponse.data[0];
      setIncident(data);
      if (data) {
        setReviewed(data.reviewed);
      }
    })();
  }, [opsReviewApi, incidentId]);

  const handleClick = async () => {
    setReviewed(!reviewed);

    try {
      if (incident) {
        await opsReviewApi.updateReviewedIncident(incidentId, !reviewed);
      } else {
        await opsReviewApi.setReviewedIncident(incidentId);
        const incidentResponse = await opsReviewApi.getReviewedIncident(
          incidentId
        );
        setIncident(incidentResponse.data[0]);
      }
    } catch (err: any) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  };

  return (
    <Checkbox
      checked={reviewed}
      onClick={async () => await handleClick()}
      disabled={disabled}
    />
  );
};
